import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import axios from "../../utils/axiosInstance";
import { MantineReactTable } from "mantine-react-table";
import { Box } from "@mantine/core";
import Button from "components/CustomButtons/Button.js";
import Pagination from "rc-pagination";
import { CircularProgress, debounce } from "@material-ui/core";
import moment from "moment";
import { toast } from "react-toastify";
const useStyles = makeStyles(styles);
export default function transactionLog() {
  const [transactionData, setTransactionData] = useState([]);
  console.log(transactionData, "transactionDatatransactionData")
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  console.log(searchText, 'searchText')
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const classes = useStyles();
  const columns = useMemo(() => [
    {
      header: "Lottery Name",
      accessorKey: "lotteryName",
    },
    {
      header: "Lottery ID",
      accessorKey: "_id",
    },
  ], []);
  const renderSubComponent = ({ row }) => {
    const logs = row.original.logs;
    if (typeof logs === "string") {
      return (
        <Box p={10} sx={{
          height: 150,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontStyle: "italic",
          color: "gray",
          fontSize: "16px",
        }}>
          {logs}
        </Box>
      );
    }
    const innerColumns = [
      { header: "User Name", accessorKey: "userName" },
      { header: "Ticket Number", accessorKey: "ticketNumber" },
      { header: "Price", accessorKey: "price" },
      { header: "Color", accessorKey: "colorNameforJackpot" },
      {
        header: "Created At",
        accessorKey: "createdAt",
        accessorFn: (row) => moment(row.createdAt).format("DD-MM-YYYY hh:mm A"),
      },
    ];

    return (
      <MantineReactTable
        columns={innerColumns}
        data={logs}
        enablePagination={true}
        enableSorting={true}
        enableGlobalFilter={true}
        enableTopToolbar={true}
        initialState={{
          pagination: {
            pageIndex: 0,
            pageSize: 5,
          },
        }}
      />
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    getData(currentPage, searchText);
  }, [currentPage, searchText]);

  const getData = async (page, search) => {
    const token = localStorage.getItem("token");
    setLoading(true);
    console.log(token);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/transactionlogs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
          params: {
            page,
            limit: pageSize,
            search: search || undefined,

          },
        }
      )
      .then((res) => {
        console.log(res);
        setTransactionData(res.data.data);
        setTotalRecords(res.data.totalCount || 0);

      })

      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setLoading(false);
      });
  };

  const debouncedSearch = useMemo(() =>
    debounce((value) => {
      setSearchText(value);
    }, 500), []
  );
  const handleDownload = async () => {
    try {
      setLoadingDownload(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/transactionlogsDownload `, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Transaction_Logs_List.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error?.response?.status === 403) {
        toast.error("You do not have permission to download this file.");
        return;
      } else {
        swal.fire({
          icon: "error",
          text: "error",
        });
      }
    } finally {
      setLoadingDownload(false); // hide loader
    }
  }
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Transaction Logs</h4>
          </CardHeader>
          <Box
            sx={{
              display: "flex",
              gap: "16px",
              flexWrap: "wrap",
              padding: "16px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "6px 12px",
                width: "300px",
                backgroundColor: "#fff",
              }}
            >
              <i className="material-icons" style={{ color: "#aaa", marginRight: "8px" }}>
                search
              </i>
              <input
                type="text"
                placeholder="Search by lottery name or ID"
                onChange={(e) => debouncedSearch(e.target.value)}
                style={{
                  border: "none",
                  outline: "none",
                  width: "100%",
                  fontSize: "14px",
                }}
              />
            </Box>
            {loadingDownload ? (
              <CircularProgress size={24} style={{ color: "black" }} />
            ) : (
              <Button
                onClick={handleDownload}
                style={{ marginLeft: "auto" }}

              >
                Export All Rows
              </Button>
            )}
          </Box>

          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "500px",

              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <CardBody>

              <MantineReactTable
                columns={columns}
                enableColumnFilterModes
                initialState={{ showColumnFilters: true }}
                positionToolbarAlertBanner="bottom"
                data={transactionData}
                enablePagination={false}
                enableFullScreenToggle={false}
                enableHiding={false}
                enableDensityToggle={false}
                enableFilters={false}
                enableExpanding
                renderDetailPanel={renderSubComponent}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                <Pagination
                  pageSize={10}
                  current={currentPage}
                  total={totalRecords}
                  onChange={handlePageChange}
                />
              </Box>
            </CardBody>
          )}
        </Card>
      </GridItem>
    </GridContainer>
  );
}
